import { StripeElementLocale } from '@stripe/stripe-js'
import { Conversion, SizeConversion } from 'types/sizeConversion'

// Sort comparator: explicit `position` first (NULLs last), tied / unset rows
// fall back to insertion order via `id`. Mirrors Product#ordered_size_conversions
// on the Rails side so the React selects render the same order as the server.
export const byPositionThenId = (
  a: Pick<SizeConversion, 'id' | 'position'>,
  b: Pick<SizeConversion, 'id' | 'position'>
): number => {
  const aPos = a.position ?? Number.POSITIVE_INFINITY
  const bPos = b.position ?? Number.POSITIVE_INFINITY

  return aPos - bPos || a.id - b.id
}

export const defaultSizeConversion = (
  locale: StripeElementLocale
): Conversion => {
  const conversion = localStorage.getItem('selectedConversion')

  if (conversion) {
    return conversion as Conversion
  }

  return conversionForLocale(locale)
}

export const conversionForLocale = (
  locale: StripeElementLocale
): Conversion => {
  if (locale === 'en') {
    return 'uk'
  }

  return 'eu'
}

export const storeConversionInLocalStorage = (conversion: Conversion): void => {
  localStorage.setItem('selectedConversion', conversion)
}
